<template>
  <Dropdown @on-click="updateI18n">
    <!-- <span>{{ $t('nav.switchLang') }}</span> -->
    <div class="languages_box">
      <span v-if="localText">{{ localText }}</span>
    </div>
    <template #list>
      <DropdownMenu style="text-align: center">
        <DropdownItem
          v-for="l in localeList"
          :key="l"
          :name="l"
          divided
        >
          {{ $t(`languageName.${l}`) }}
        </DropdownItem>
        <!-- <DropdownItem name="en" divided>
        English</DropdownItem> -->
      </DropdownMenu>
    </template>
  </Dropdown>
</template>
<script>
import i18nMixins from '../../layouts/i18n-mixin'
import { mapState } from 'vuex'
export default {
  mixins: [i18nMixins],
  data() {
    return {}
  },
  computed: {
    ...mapState(['localText'])
  },
  mounted() {
    this.initI18n()
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
.languages_box {
  width: 24px;
  height: 24px;
  line-height: 22px;
  text-align: center;
  border-radius: 50%;
  background-color: #f4f6f8;
  border: 1px solid #e2e2e3;
  font-size: 12px;
}
</style>
